import { staticServerDomain } from 'shared/constants'

function getSlotImage(slotId, sectionId) {
  const slotIdStr = slotId.toLowerCase()
  const sectionIdLower = sectionId.toLowerCase()
  return `https://static.${staticServerDomain}/outcome/235x235/${sectionIdLower}/${slotIdStr}.jpg`
}

const sectionNames = {
  greentube: 'GT',
  gaminator: 'Gaminator',
  netent: 'NetEnt',
  igrosoft: 'Igrosoft',
  playtech: 'PlayTech',
  igt: 'IGT',
  quickspin: 'QuickSpin',
  apollo: 'Apollo',
  kajot: 'Kajot',
  aristocrat: 'Aristocrat',
  amatic: 'Amatic',
  wazdan: 'Wazdan',
  microgaming: 'Microgaming',
  egt: 'EGT',
  merkur: 'Merkur',
  all: 'All',
}

const shortSlotsList = [
  {
    sectionId: 'netent',
    id: 'reel_rush_html',
  },
  {
    sectionId: 'wazdan',
    id: 'lf_wzdn',
  },
  {
    sectionId: 'microgaming',
    id: 'thunderstruckii_mg_flash',
  },
  {
    sectionId: 'greentube',
    id: 'bookofradeluxe_gt_html',
  },
  {
    sectionId: 'amatic',
    id: 'admiral_nelson_original',
  },
  {
    sectionId: 'igrosoft',
    id: 'pirate_original_html',
  },
  {
    sectionId: 'igt',
    id: 'cash_coaster',
  },
  {
    sectionId: 'aristocrat',
    id: '50_dragons',
  },
]

export { getSlotImage, sectionNames, shortSlotsList }
